var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"id":"printJS-form1"}},[_c('div',{ref:"printer_doc",attrs:{"id":"printer2"}})])}
var staticRenderFns = []

export { render, staticRenderFns }